import React from 'react'

const Loader = () => {
  return (
    <div>

<div id="container"> 

<div id='singleMovie-container1'>
    <div class="skeleton-img skeleton">
     </div>

     <div class="text-skeleton  skeleton">

     </div>
    </div>




 
    <div id='singleMovie-container1'>
        <div class="skeleton-img skeleton">
         </div>

         <div class="text-skeleton  skeleton">

         </div>
        </div>





        
        <div id='singleMovie-container1'>
            <div class="skeleton-img skeleton">
             </div>
    
             <div class="text-skeleton  skeleton">
    
             </div>
            </div>
    
    
    
    
           
            <div id='singleMovie-container1'>
                <div class="skeleton-img skeleton">
                 </div>
        
                 <div class="text-skeleton  skeleton">
        
                 </div>
                </div>
        

               
                <div id='singleMovie-container1'>
                    <div class="skeleton-img skeleton">
                     </div>
            
                     <div class="text-skeleton  skeleton">
            
                     </div>
                    </div>
            
            
            
            
                    
                    <div id='singleMovie-container1'>
                        <div class="skeleton-img skeleton">
                         </div>
                
                         <div class="text-skeleton  skeleton">
                
                         </div>
                        </div>

                        <div id='singleMovie-container1'>
                            <div class="skeleton-img skeleton">
                             </div>
                    
                             <div class="text-skeleton  skeleton">
                    
                             </div>
                            </div>


                            <div id='singleMovie-container1'>
                                <div class="skeleton-img skeleton">
                                 </div>
                        
                                 <div class="text-skeleton  skeleton">
                        
                                 </div>
                                </div>
                
</div>
    </div>
  )
}

export default Loader